import { render, staticRenderFns } from "./slider-slot.mpx?vue&type=template&id=3f8a50ad&isComponent&outputPath=components%2Fslider-slot02a73942%2Findex"
import script from "./slider-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslider-slot02a73942%2Findex"
export * from "./slider-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslider-slot02a73942%2Findex"
import style0 from "./slider-slot.mpx?vue&type=style&index=0&id=3f8a50ad&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_02a73942%22%7D&isComponent&outputPath=components%2Fslider-slot02a73942%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports